let type
let url

export const classesInjection = (view) => {
  view = view ?? document.querySelector("[data-router-view]")
  const classes = view.getAttribute("data-class-injection")

  requestAnimationFrame(() => {
    document.body.removeAttribute("class")
    view.removeAttribute("data-class-injection")
    document.body.classList.add(...classes.split(" "))
  })
}

export const rewriteLinks = () => {
  const links = document.querySelectorAll("a[href]")
  if (window.location.port === "3000") {
    links.forEach((link) => {
      const href = link.getAttribute("href")
      if (href === "") return
      if (href.includes(":3000")) return
      if (!href.includes(window.location.hostname)) return
      link.setAttribute(
        "href",
        href.replace(window.location.hostname, window.location.host)
      )
    })
  }
}
